















import Vue from "vue";
export default Vue.extend({
  name: "CheckboxGroupPost",

  model: {
    prop: "checked",
    event: "change"
  },

  props: {
    label: {
      type: String,
      required: false
    },
    checked: {
      type: Boolean
    }
  },

  data: () => {
    return {
      id: ""
    };
  },

  created(): void {
    this.id = `form-group-${this._uid}`;
  },

  computed: {
   
  }
});
